import { makeStyles, tokens, shorthands } from "@fluentui/react-components";

export const useFundManagementStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    boxSizing: "border-box",
  },
  dropdownContainer: {
    marginBottom: tokens.spacingVerticalL,
    width: "100%",
  },
  label: {
    marginBottom: tokens.spacingVerticalL,
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
  },
  dropdown: {
    width: "100%",
    marginTop: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalL,
    minWidth: 0,
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    gap: tokens.spacingHorizontalM,
    marginBottom: tokens.spacingVerticalL,
    flexWrap: "wrap",
    width: "100%",
  },
  insertButton: {},
  insertAllButton: {},
  refetchButton: {},
  clearButton: {
    backgroundColor: "#d13438",
    color: "white",
    // borderColor: "#d13438",
    "&:hover:not(:disabled)": {
      backgroundColor: "#a4262c",
      // borderColor: "#a4262c",
    },
  },
  successMessage: {
    marginTop: tokens.spacingVerticalM,
    padding: tokens.spacingVerticalM,
    backgroundColor: tokens.colorPaletteGreenBackground2,
    color: tokens.colorPaletteGreenForeground1,
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    fontSize: tokens.fontSizeBase300,
    textAlign: "center",
    width: "100%",
    boxSizing: "border-box",
  },
  errorMessage: {
    marginTop: tokens.spacingVerticalM,
    padding: tokens.spacingVerticalM,
    backgroundColor: tokens.colorPaletteRedBackground2,
    color: tokens.colorPaletteRedForeground1,
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    fontSize: tokens.fontSizeBase300,
    textAlign: "center",
    width: "100%",
    boxSizing: "border-box",
  },
  tooltip: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundInverted,
  },
});
